import { AuthProvider } from '@sdk/authentication/AuthContext';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import TimesheetViewModal from '@web/timesheets/TimesheetViewModal/TimesheetViewModal';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';

const TimesheetViewModalAngular = ({
  Authentication,
  PersonaCollection,
  shift,
  isTimesheetPreviewActive = false,
  onClose,
  onTimesheetSave,
}) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <PersonaCollectionContext.Provider value={PersonaCollection}>
          <QueryClientProvider>
            <TimesheetViewModal
              shift={shift}
              isTimesheetPreviewActive={isTimesheetPreviewActive}
              onClose={onClose}
              onTimesheetSave={onTimesheetSave}
            />
          </QueryClientProvider>
          <ToastComponent />
        </PersonaCollectionContext.Provider>
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: TimesheetViewModalAngular,
  dependencies: ['Authentication', 'PersonaCollection'],
  bindings: {
    shift: '<',
    isTimesheetPreviewActive: '<',
    onClose: '&',
    onTimesheetSave: '&',
  },
};
